import React from "react";
import { Box, Image, Flex, Title } from "@mantine/core";
import { motion } from "framer-motion";
import Typewriter from "typewriter-effect";
import logoImage from "../../assets/logo/logo-full.svg";
import SymbolLeft from "../../assets/logo/symbol_left.svg";
import SymbolRight from "../../assets/logo/symbol_right.svg";
import { useTranslation } from "react-i18next";

const LoginTopSection = () => {
	const { t } = useTranslation();
	
	const containerVariants = {
		hidden: { opacity: 0 },
		visible: {
			opacity: 1,
			transition: {
				staggerChildren: 0.3,
				duration: 0.4,
				ease: "easeInOut"
			}
		}
	};
	
	const itemVariants = {
		hidden: { opacity: 0, y: 20, scale: 4 },
		visible: { 
			opacity: 1, 
			y: 0,
			scale: 1,
			transition: { 
				duration: 0.4,
				ease: "easeInOut"
			}
		}
	};

	return (
		<Flex direction={"column"} align={"center"}>
			<motion.div
				variants={containerVariants}
				initial="hidden"
				animate="visible"
			>
				<motion.div variants={itemVariants}>
					<Box>
						<Image
							src={logoImage}
							h={{ base: 32, sm: 40, md: 48 }}
							mb={".5rem"}
							w={"auto"}
						/>
					</Box>
				</motion.div>
				
				<Flex align={"center"} direction={"row"}>
					<motion.div variants={itemVariants}>
						<Image src={SymbolLeft} h={{ base: 20, sm: 24, md: 28 }} w={"auto"} />
					</motion.div>
					
					<motion.div variants={itemVariants}>
						<Box style={{ height: "2.5rem", display: "flex", alignItems: "center" }}>
							<Title fw={200} fz={{ base: "1.2rem", sm: "1.5rem", md: "1.8rem" }}>
								<Typewriter
									onInit={(typewriter) => {
										typewriter
											.changeDelay(50)
											.typeString(t("landing.mainMessage"))
											.start();
									}}
									options={{
										cursor: "",
									}}
								/>
							</Title>
						</Box>
					</motion.div>
					
					<motion.div variants={itemVariants}>
						<Image src={SymbolRight} h={{ base: 20, sm: 24, md: 28 }} w={"auto"} />
					</motion.div>
				</Flex>
			</motion.div>
		</Flex>
	);
};

export default LoginTopSection;
